import { Directive, type OnDestroy, inject } from '@angular/core';
import type { UntypedFormGroup } from '@angular/forms';
import type {
  IDashboardWidgetTypeConfig,
  IWidgetTypeConfigComponent,
} from '@clean-code/shared/components/ui-dashboard';
import { DashboardWidgetFacade } from '@clean-code/shared/dashboard/widget/domain';
import { Subject } from 'rxjs';

@Directive()
export class BaseWidgetTypeConfigComponent<T extends IDashboardWidgetTypeConfig>
  implements IWidgetTypeConfigComponent, OnDestroy
{
  public form!: UntypedFormGroup;

  protected closeSubject = new Subject<void>();

  private widgetFacade = inject(DashboardWidgetFacade);
  public config = this.widgetFacade.config;

  ngOnDestroy(): void {
    this.closeSubject.next();
    this.closeSubject.complete();
  }
}
